var render = function render(_c, _vm) {
  return _c("div", { staticClass: "smDevModal grid grid--full-height" }, [
    _c(
      "div",
      { staticClass: "smDevModal__placeholder" },
      [
        _c("svgicon", { attrs: { icon: "fence", height: "78", width: "78" } }),
        _c("p", { staticClass: "text-medium mg mg--b-1 mg--t-6 black" }, [
          _vm._v(_vm._s(_vm.parent.$t("smDevModal.title")))
        ]),
        _c("p", { staticClass: "text-small black" }, [
          _vm._v(_vm._s(_vm.parent.$t("smDevModal.text")))
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }